import React from 'react';
import {
  Box,
  Container,
  Paper,
  Title,
  Text,
  SimpleGrid,
  ThemeIcon,
  Badge,
  Group,
  Button,
  Stack,
  Center,
} from '@mantine/core';
import {
  IconShieldLock,
  IconCar,
  IconUsers,
  IconFileAnalytics,
  IconChevronRight,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const navigate = useNavigate();

  const modules = [
    {
      title: 'Araç Takip',
      description: 'Plaka kaydı, giriş-çıkış işlemleri ve araç sorgulama.',
      icon: <IconCar size={32} stroke={1.5} />,
      color: 'blue',
      badge: 'Filo',
      path: '/istanbul-office/vehicle',
    },
    {
      title: 'Misafir Takip',
      description: 'Ziyaretçi kaydı, kimlik tarama ve ziyaret geçmişi.',
      icon: <IconUsers size={32} stroke={1.5} />,
      color: 'teal',
      badge: 'Ziyaretçi',
      path: '/istanbul-office/guest',
    },
    {
      title: 'Gider Takip',
      description: 'Ziyaretçi kaydı, kimlik tarama ve ziyaret geçmişi.',
      icon: <IconUsers size={32} stroke={1.5} />,
      color: 'red',
      badge: 'Gider',
      path: '/istanbul-office/expense',
    },
    {
      title: 'Raporlar',
      description: 'Günlük giriş-çıkış istatistikleri ve sistem raporları.',
      icon: <IconFileAnalytics size={32} stroke={1.5} />,
      color: 'grape',
      badge: 'Analiz',
      path: '/istanbul-office/reports',
    },
  ];

  return (
    <Box
      style={{
        backgroundColor: '#f8f9fa', // Ferah, açık gri/beyaz arka plan
        padding: '40px 24px',
      }}
    >
      <Container size="xl">
        {/* Üst Bilgi Paneli */}
        <Paper
          radius="xl"
          p="xl"
          mb="xl"
          bg="white"
          style={{
            border: '1px solid #e9ecef',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)',
          }}
        >
          <Group justify="space-between" align="center">
            <Group gap="lg">
              <ThemeIcon
                size={72}
                radius="xl"
                variant="light"
                color="blue"
              >
                <IconShieldLock size={40} stroke={1.5} />
              </ThemeIcon>

              <div>
                <Title order={2} c="dark.9" fw={800} style={{ letterSpacing: '-0.5px' }}>
                  İstanbul Ofis Operasyon Paneli
                </Title>
                <Text c="dimmed" size="md" mt={4}>
                  Operasyon modüllerine hızlı erişim sağlayın.
                </Text>
              </div>
            </Group>
          </Group>
        </Paper>

        {/* Ana Modül Alanı */}
        <Paper
          p={{ base: 'xl', md: 40 }}
          radius="xl"
          bg="white"
          style={{
            border: '1px solid #e9ecef',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.03)',
          }}
        >
          <Center mb={40}>
            <Stack gap={8} align="center">
            </Stack>
          </Center>

          <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="xl">
            {modules.map((module) => (
              <Paper
                key={module.title}
                radius="xl"
                p="xl"
                withBorder
                onClick={() => navigate(module.path)}
                style={{
                  cursor: 'pointer',
                  transition: 'all 0.25s ease',
                  borderColor: '#f1f3f5',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.08)';
                  e.currentTarget.style.borderColor = `var(--mantine-color-${module.color}-3)`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#f1f3f5';
                }}
              >
                <Group justify="space-between" align="flex-start" mb="lg">
                  <ThemeIcon
                    size={64}
                    radius="xl"
                    variant="light"
                    color={module.color}
                  >
                    {module.icon}
                  </ThemeIcon>

                  <Badge variant="light" color={module.color} radius="sm" size="lg">
                    {module.badge}
                  </Badge>
                </Group>

                <Title order={3} size="h4" fw={700} c="dark.9" mb={12}>
                  {module.title}
                </Title>

                <Text c="dimmed" size="sm" mb={32} style={{ lineHeight: 1.6, minHeight: '44px' }}>
                  {module.description}
                </Text>

                <Button
                  fullWidth
                  radius="md"
                  variant="light"
                  color={module.color}
                  size="md"
                  rightSection={<IconChevronRight size={18} />}
                  onClick={(e) => {
                    e.stopPropagation(); // Kart tıklamasını engellememesi için
                    navigate(module.path);
                  }}
                  style={{ transition: 'all 0.2s ease' }}
                >
                  Modüle Git
                </Button>
              </Paper>
            ))}
          </SimpleGrid>
        </Paper>
      </Container>
    </Box>
  );
}